/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet } from 'react-native';

import SociollaText from '@components/sociolla/SociollaText';
import Photo from '@components/global/Photo';
import Colors from '@global/colors';

function RankingItem(props) {
  const { index = 0, style = {} } = props;
  return (
    <View style={[styles.rankingItem, style]}>
      <View style={styles.row}>
        <View
          style={[
            styles.rankingNumber,
            index == 0 ? { backgroundColor: Colors.yellow0 } : {},
            index == 1 ? { backgroundColor: Colors.grey1 } : {},
            index == 2 ? { backgroundColor: Colors.orange0 } : {},
          ]}>
          <SociollaText type="medium" style={styles.rankingNumberText}>
            {index + 1}
          </SociollaText>
        </View>
        <View style={styles.row}>
          <Photo image={''} width={15} height={15} style={styles.minRight} />
          <SociollaText style={styles.rankingName}>Qin Sin</SociollaText>
        </View>
      </View>
      <SociollaText type="medium" style={styles.rankingTotal}>
        Rp 200M
      </SociollaText>
    </View>
  );
}

const styles = StyleSheet.create({
  rankingItem: {
    width: '100%',
    paddingVertical: 10,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  rankingNumber: {
    marginRight: 10,
    borderRadius: 25,
    backgroundColor: Colors.grey0,
    width: 17,
    height: 17,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rankingNumberText: { fontSize: 10 },
  rankingName: { fontSize: 12 },
  rankingTotal: { fontSize: 13 },
  row: { flexDirection: 'row', alignItems: 'center' },
  minRight: { marginRight: 5 },
});

export default React.memo(RankingItem, (prev, next) => prev == next);
